import React from 'react';

const DEFAULT_ERROR_MESSAGE = 'Ha ocurrido un error. Por favor, contacte a soporte.';
const DEFAULT_ERROR_TITLE = 'Algo ha salido mal';
const DEFAULT_ERROR_DESCRIPTION = '';

interface Props {
    errorMessage?: string;
    title?: string;
    errorDescription?: string;
}

export default function ErrorMessage({
    errorMessage = DEFAULT_ERROR_MESSAGE,
    title = DEFAULT_ERROR_TITLE,
    errorDescription = DEFAULT_ERROR_DESCRIPTION,
}: Props) {
    return (
        <div
            className='alert alert-danger alert-dismissible my-3 p-3'
            style={{
                borderRadius: 10,
            }}
            role='alert'
        >
            <h4 className='alert-heading mb-2'>{title}</h4>
            <p>{errorMessage}</p>
            <p className='mb-0'>{errorDescription}</p>
        </div>
    );
}
